/* eslint-disable */
import { useCallback, useEffect, useRef, useState } from "react";
import "./sessionSettingsModalBody.scss";
import { current, nanoid } from "@reduxjs/toolkit";
import MainButton from "components/common/reuseableButtonComponent/MainButton";
import ResetIcon from "components/common/icons/reset";
import DeleteIcon from "components/common/icons/deleteIcon";
import DownArrow from "components/common/icons/downArrow";
import { updateSessionActivityAPI } from "api/session";
import { useDispatch } from "react-redux";
import { getSessionList } from "store/sessionListSlice";
import SwapIcon from "components/common/icons/swapIcon";
import ListItem from "rsuite/esm/List/ListItem";
import SaveIcon from "components/common/icons/saveIcon";
import { Responsive, WidthProvider } from "react-grid-layout";
import { isEqual } from "lodash";
import DndIcon from "components/common/icons/dndIcon";

const ResponsiveGridLayout = WidthProvider(Responsive);

const SessionSettingsModalBody = ({
  tableTabs,
  user,
  rerunMetricsHandler,
  rerunMetricButtonText,
  discardSessionHandler,
  currentActivity,
  activityList,
  sessionID,
  rerunMetrics,
  sessionMetricsToggled,
  disabledGraphIDs,
  setDisabledGraphIDs,
  getGraphsRenedered,
  disabledSummaryIDs,
  setDisabledSummaryIDs,
  getSummariesRendered,
  toggledSummaryIDs,
  updateSessionLayout,
  setCustomGridLayout,
  customGridLayout,
  thisSession,
}) => {
  console.log("customGridLayout :", customGridLayout);

  const gridLayout = customGridLayout.map((item) => ({
    ...item,
    h: 1, // Use a function to determine height dynamically
  }));

  console.log("Grid Layout Modified : ", gridLayout);

  //state used for tab navigation with this modal
  const [whichTabSelected, setWhichTabSelected] = useState(0);
  //Session activity selection state
  const [selectedActivity, setSlectedActivity] = useState({ name: "", id: "" });

  const [metricsSelectedForToggle, setMetricsSelectedForToggle] = useState({
    selectedFromHidden: [],
    selectedFromDisplayed: [],
  });
  const [metricsSummarySelectedForToggle, setMetricsSummarySelectedForToggle] =
    useState({
      asymmSelectedFromHidden: [],
      kpiSelectedFromHidden: [],
      asymmSelectedFromDisplayed: [],
      kpiSelectedFromDisplayed: [],
    });

  // save action state
  const [saveActionInitialized, setSaveActionInitialized] = useState({
    metrics: false,
    summary: false,
  });

  // enable drag and drop
  const [editingLayout, setEditingLayout] = useState(false);

  const dispatch = useDispatch();

  const checkIfCurentTabIsSelected = (currentTab) => {
    return (
      tableTabs.filter((item) => item)?.[whichTabSelected]?.tabName ===
      currentTab
    );
  };

  const customGridLayoutRef = useRef(gridLayout);
  console.log("custom Grid :", customGridLayoutRef);

  // const handleLayoutChange = useCallback((newLayout) => {
  //   // // Only update ref if layout actually changes
  //   console.log("callback initiated");
  //   console.log("customGridLayoutRef.current :", customGridLayoutRef.current);
  //   console.log("newLayout :", newLayout);
  //   console.log(
  //     JSON.stringify(customGridLayoutRef.current) !== JSON.stringify(newLayout)
  //   );
  //   if (
  //     JSON.stringify(customGridLayoutRef.current) !== JSON.stringify(newLayout) && newLayout.length !== 0
  //   ) {
  //     customGridLayoutRef.current = newLayout;
  //     setCustomGridLayout(customGridLayoutRef.current);
  //     console.log("TimesHere");
  //   }
  // }, []);

  // const handleLayoutChange = useCallback((newLayout) => {
  //   console.log("callback initiated");
  //   console.log("customGridLayoutRef.current :", customGridLayoutRef.current);
  //   console.log("newLayout :", newLayout);

  //   if (newLayout.length === 0) return; // Prevent updating when layout is empty

  //   const isDifferent =
  //     JSON.stringify(customGridLayoutRef.current) !== JSON.stringify(newLayout);

  //   console.log(isDifferent);
  //   if (isDifferent) {
  //     customGridLayoutRef.current = newLayout;
  //     setCustomGridLayout(newLayout);
  //     // localStorage.setItem("customGridLayout", JSON.stringify(newLayout));
  //     console.log("TimesHere");
  //   }
  // }, []);

  // const storedLayout = JSON.parse(localStorage.getItem("userLayout")) || [];

  // console.log(storedLayout)

  // useEffect(() => {
  //   console.log(storedLayout)
  //   if (storedLayout?.sessionLayout?.[thisSession?.ActivityName?.toLowerCase()]
  //   ?.gridLayout.length > 0) {
  //     console.log("Setting Values")
  //     setCustomGridLayout(storedLayout?.sessionLayout?.[thisSession?.ActivityName?.toLowerCase()]
  //     ?.gridLayout.map((item) => ({
  //       ...item,
  //       h: 1, // Use a function to determine height dynamically
  //     })));
  //   }
  // }, []);

  const storedLayout = JSON.parse(localStorage.getItem("userLayout")) || [];
  console.log("Stored layout:", storedLayout);

  // useEffect(() => {
  //   console.log("Checking stored layout on mount");
  //   const sessionLayout =
  //     storedLayout?.sessionLayout?.[thisSession?.ActivityName?.toLowerCase()]
  //       ?.gridLayout || [];

  //   if (sessionLayout.length > 0) {
  //     console.log("Setting Values from Local Storage");
  //     const updatedLayout = sessionLayout.map((item) => ({
  //       ...item,
  //       h: 1, // Adjust height dynamically
  //     }));

  //     customGridLayoutRef.current = updatedLayout; // Set ref immediately
  //     setCustomGridLayout(updatedLayout);
  //   }
  // }, []);

  // Only updates when actual changes occur
  const handleLayoutChange = useCallback((newLayout) => {
    console.log("callback initiated");
    console.log("customGridLayoutRef.current:", customGridLayoutRef.current);
    console.log("newLayout:", newLayout);

    if (newLayout.length === 0) return; // Prevent updating when layout is empty

    const isDifferent =
      JSON.stringify(customGridLayoutRef.current) !== JSON.stringify(newLayout);

    console.log("Layout different?", isDifferent);
    if (isDifferent) {
      customGridLayoutRef.current = newLayout;
      // setCustomGridLayout(newLayout);
      // localStorage.setItem("customGridLayout", JSON.stringify(newLayout));
      console.log("Updated customGridLayoutRef");
    }
  }, []);

  console.log(customGridLayout);

  //added graph render here to make sure all charts are loaded before setting the renderd charts
  useEffect(() => {
    getGraphsRenedered();
  }, [disabledGraphIDs]);
  useEffect(() => {
    getSummariesRendered();
  }, [disabledSummaryIDs, disabledGraphIDs]);

  //handlers for Session Settings

  //handle session change button click
  const handleSessionActivityChange = (name, id) => {
    setSlectedActivity({ name: name, id: id });
  };

  //handle activity change submission
  const submitActivityChange = async () => {
    let postBody = {
      id: sessionID,
      aid: selectedActivity.id,
    };
    //if poth postbody elements exist
    if (selectedActivity.id && sessionID) {
      let updateSessionAactivity = await updateSessionActivityAPI(postBody);

      //if response status is 200
      if (updateSessionAactivity.status === 200) {
        await rerunMetrics();
        dispatch(getSessionList());
      }
    }
  };

  //handle button clicked state
  const handleSaveInitializedButton = (operation) => {
    const updateSaveAction = (key) => {
      setSaveActionInitialized((prev) => ({ ...prev, [key]: true }));
      setTimeout(() => {
        setSaveActionInitialized((prev) => ({ ...prev, [key]: false }));
      }, 1500);
    };

    if (operation === "metrics" || operation === "summary") {
      updateSaveAction(operation);
    }
  };

  const handleMetricToggle = (action, metric) => {
    const isHideAction = action === "hide";
    const targetKey = isHideAction
      ? "selectedFromDisplayed"
      : "selectedFromHidden";

    setMetricsSelectedForToggle((prevState) => {
      const targetArray = prevState[targetKey];
      const isMetricSelected = targetArray.includes(metric);

      const updatedMetrics = isMetricSelected
        ? targetArray.filter((item) => item !== metric) // Remove metric if it exists
        : [...targetArray, metric]; // Add metric if it doesn't exist

      return {
        ...prevState,
        [targetKey]: updatedMetrics,
      };
    });
  };

  const handleSummaryToggle = (action, summaryType, metric) => {
    const summaryTypesMap = {
      kpi: {
        displayedKey: "kpiSelectedFromDisplayed",
        hiddenKey: "kpiSelectedFromHidden",
      },
      asymm: {
        displayedKey: "asymmSelectedFromDisplayed",
        hiddenKey: "asymmSelectedFromHidden",
      },
    };

    const { displayedKey, hiddenKey } = summaryTypesMap[summaryType];
    const targetKey = action === "hide" ? displayedKey : hiddenKey;

    setMetricsSummarySelectedForToggle((prevState) => {
      const targetArray = prevState[targetKey];
      const isMetricSelected = targetArray.includes(metric);

      const updatedMetrics = isMetricSelected
        ? targetArray.filter((item) => item !== metric) // Remove the metric
        : [...targetArray, metric]; // Add the metric

      return {
        ...prevState,
        [targetKey]: updatedMetrics,
      };
    });
  };

  const handleMetricSwap = () => {
    let updatedDisabledGraphIDs = [...disabledGraphIDs];

    // Add new disabled metrics
    if (metricsSelectedForToggle.selectedFromDisplayed?.length > 0) {
      updatedDisabledGraphIDs = [
        ...updatedDisabledGraphIDs,
        ...metricsSelectedForToggle.selectedFromDisplayed,
      ];
    }

    // Remove unhidden metrics
    if (metricsSelectedForToggle.selectedFromHidden?.length > 0) {
      updatedDisabledGraphIDs = updatedDisabledGraphIDs.filter(
        (metric) =>
          !metricsSelectedForToggle.selectedFromHidden.includes(metric)
      );
    }

    // Set the updated state once
    setDisabledGraphIDs(updatedDisabledGraphIDs);

    // Reset metricsSelectedForToggle
    setMetricsSelectedForToggle({
      selectedFromHidden: [],
      selectedFromDisplayed: [],
    });
  };

  const handleSummarySwap = () => {
    let updatedDisabledSummaryKpiIDs = [
      ...disabledSummaryIDs.disabledKpiSummaryIDs,
    ];
    let updatedDisabledSummaryAsymmIDs = [
      ...disabledSummaryIDs.disabledAsymmetrySummaryIDs,
    ];

    // Add new disabled summaries
    if (metricsSummarySelectedForToggle.kpiSelectedFromDisplayed?.length > 0) {
      updatedDisabledSummaryKpiIDs = [
        ...updatedDisabledSummaryKpiIDs,
        ...metricsSummarySelectedForToggle.kpiSelectedFromDisplayed,
      ];
    }
    if (
      metricsSummarySelectedForToggle.asymmSelectedFromDisplayed?.length > 0
    ) {
      updatedDisabledSummaryAsymmIDs = [
        ...updatedDisabledSummaryAsymmIDs,
        ...metricsSummarySelectedForToggle.asymmSelectedFromDisplayed,
      ];
    }

    // Remove unhidden summaries
    if (metricsSummarySelectedForToggle.kpiSelectedFromHidden?.length > 0) {
      updatedDisabledSummaryKpiIDs = updatedDisabledSummaryKpiIDs.filter(
        (metric) =>
          !metricsSummarySelectedForToggle.kpiSelectedFromHidden.includes(
            metric
          )
      );
    }
    if (metricsSummarySelectedForToggle.asymmSelectedFromHidden?.length > 0) {
      updatedDisabledSummaryAsymmIDs = updatedDisabledSummaryAsymmIDs.filter(
        (metric) =>
          !metricsSummarySelectedForToggle.asymmSelectedFromHidden.includes(
            metric
          )
      );
    }

    // Set the updated state once
    setDisabledSummaryIDs({
      disabledKpiSummaryIDs: updatedDisabledSummaryKpiIDs,
      disabledAsymmetrySummaryIDs: updatedDisabledSummaryAsymmIDs,
    });

    // Reset metricsSelectedForToggle
    setMetricsSummarySelectedForToggle({
      asymmSelectedFromHidden: [],
      kpiSelectedFromHidden: [],
      asymmSelectedFromDisplayed: [],
      kpiSelectedFromDisplayed: [],
    });
  };

  return (
    <div className="activity_settings_modal_body_container">
      <div className="activity_settings_modal_tabs">
        {tableTabs
          .filter((item) => item)
          .map((item, index) => (
            <div
              key={nanoid()}
              className={`activity_settings_modal_tab ${
                whichTabSelected === index
                  ? "activity_settings_modal_tab_active"
                  : ""
              }`}
              style={{
                width: `${100 / tableTabs?.filter((item) => item)?.length}%`,
              }}
              onClick={() => setWhichTabSelected(index)}
            >
              {item.tabName}
            </div>
          ))}
      </div>
      <div className="activity_settings_modal_tab_content_container">
        {checkIfCurentTabIsSelected("Session") ? (
          <div className="session_settings_container">
            <div className="activity_change_container">
              <div className="activity_change_modal_container">
                <div className="activity_change_modal_heading">
                  <h1>Change Activity Type</h1>
                </div>
                <div className="activity_change_type">
                  <h3 className="current_activity">{currentActivity}</h3>
                  <div className="activity_arrow">
                    <DownArrow direction={"right"} size="12" />
                  </div>
                  <h3
                    className={`future_activity ${
                      selectedActivity?.name.length > 0
                        ? "future_activity_selected"
                        : "future_activity_not_selected"
                    }`}
                  >
                    {selectedActivity?.name.length > 0
                      ? selectedActivity.name
                      : "Select"}
                  </h3>
                </div>
              </div>
              <div className="activitiy_table">
                {activityList.map(
                  (item) =>
                    //remove the current activity as well as the activity type id for activities that metrics arent ready for
                    item?.name !== currentActivity &&
                    item.activityTypeID !== 3 &&
                    item.activityTypeID !== 4 && (
                      <div
                        key={item.id}
                        id={item.id}
                        className={`activity_item ${
                          item?.name === selectedActivity?.name
                            ? "activity_item_selected"
                            : ""
                        }`}
                        onClick={() =>
                          handleSessionActivityChange(item?.name, item.id)
                        }
                      >
                        {item?.name}
                      </div>
                    )
                )}
              </div>
              <div
                className="activity_button"
                onClick={() => submitActivityChange()}
              >
                <MainButton
                  buttonText={"Confirm Change"}
                  buttonPop={selectedActivity?.name.length > 0 ? true : false}
                />
              </div>
            </div>
            {user.permissionLevel === 1 ? (
              <div className="super_admin_controls">
                <div className="summary_controls_buttons">
                  <div
                    className="summary_controls_button"
                    onClick={() => discardSessionHandler()}
                  >
                    <MainButton
                      buttonText={"Discard Session"}
                      ButtonIcon={DeleteIcon}
                      buttonIconSize={16}
                      buttonFontSize={12}
                      buttonImportant={true}
                      buttonBoxShadow={true}
                    />
                  </div>
                  <div
                    className="summary_controls_button"
                    onClick={() => rerunMetricsHandler()}
                  >
                    <MainButton
                      buttonText={rerunMetricButtonText}
                      ButtonIcon={ResetIcon}
                      buttonIconSize={16}
                      buttonFontSize={12}
                      buttonImportant={
                        rerunMetricButtonText === "Re-running Metrics"
                          ? true
                          : false
                      }
                      buttonDisabled={
                        rerunMetricButtonText === "Re-running Metrics"
                          ? true
                          : false
                      }
                      buttonLoading={
                        rerunMetricButtonText === "Re-running Metrics"
                          ? true
                          : false
                      }
                      buttonTooltip={"Metric Rerun Initialised"}
                      buttonBoxShadow={true}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}

        {checkIfCurentTabIsSelected("Metrics") ? (
          <div className="metrics_settings_container">
            <div className="metric_settings_containers">
              <div className="toggleable_metric_container">
                <h4>Hidden Metrics</h4>
                <div className="metric_container">
                  <div className="scrollable_content scrollable_content_margin">
                    {disabledGraphIDs.map((item) => (
                      <div
                        key={nanoid()}
                        className={`toggleable_metric ${
                          metricsSelectedForToggle.selectedFromHidden.includes(
                            item
                          )
                            ? "toggled_metric"
                            : ""
                        }`}
                        onClick={() => handleMetricToggle("show", item)}
                      >
                        {item?.split("_")?.join(" ")}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="toggle_swapper_button_container">
                <div
                  className="swap_metrics_button"
                  onClick={() => handleMetricSwap()}
                >
                  <SwapIcon size={24} />
                </div>
              </div>
              <div className="toggleable_metric_container">
                <h4>Displayed Metrics</h4>
                <div className="metric_container">
                  {/* <div className="scrollable_content"> */}
                  <ResponsiveGridLayout
                    className="scrollable_content"
                    rowHeight={17}
                    breakpoints={{ lg: 0 }}
                    cols={{ lg: 1 }}
                    isResizable={false}
                    isRearrangeable={true}
                    isDraggable={editingLayout ? true : false}
                    margin={[0, 13]}
                    layouts={{ lg: gridLayout }}
                    onLayoutChange={(e) => {
                      handleLayoutChange(e);
                      console.log(e);
                    }}
                  >
                    {sessionMetricsToggled
                      .filter((item) => !disabledGraphIDs.includes(item))
                      .map((item) => (
                        <div
                          key={item}
                          className={`toggleable_metric ${
                            metricsSelectedForToggle.selectedFromDisplayed.includes(
                              item
                            )
                              ? "toggled_metric"
                              : ""
                          }`}
                          onClick={() => {
                            !editingLayout
                              ? handleMetricToggle("hide", item)
                              : null;
                          }}
                        >
                          <p>{item?.split("_")?.join(" ")}</p>
                        </div>
                      ))}
                  </ResponsiveGridLayout>
                  {/* </div> */}
                </div>
              </div>
            </div>
            <div className="metric_settings_button_container">
              <div
                className="toggleable_metric_button"
                onClick={() => {
                  updateSessionLayout(), handleSaveInitializedButton("metrics");
                }}
              >
                <MainButton
                  ButtonIcon={SaveIcon}
                  buttonIconSize={16}
                  buttonLoading={saveActionInitialized.metrics}
                  buttonText={
                    !saveActionInitialized.metrics ? "Save" : "Saving"
                  }
                  buttonImportant={saveActionInitialized.metrics}
                />
              </div>

              {/* <div
                className="toggleable_metric_button"
                onClick={() => {
                  setEditingLayout((prev) => !prev);
                }}
              >
                <MainButton
                  ButtonIcon={DndIcon}
                  buttonIconSize={16}
                  buttonText={!editingLayout ? "Edit Layout" : "Apply Layout"}
                  buttonTooltip={
                    "Toggle on Drag and Drop on the Displayed Metrics section to re-order the metrics in the section."
                  }
                  buttonForceTooltip={!editingLayout}
                />
              </div> */}
            </div>
          </div>
        ) : null}

        {checkIfCurentTabIsSelected("Summary") ? (
          <div className="summary_settings_container">
            <div className="metric_settings_containers">
              <div className="toggleable_metric_container">
                <h4>Hidden Metrics Summary</h4>
                <div className="metric_container">
                  <div className="scrollable_content">
                    {/* Scrollable displayed will go here*/}
                    {!disabledGraphIDs.includes("KPI_Session_Summary") ? (
                      <div className="kpi_toggleable_container">
                        <h4>KPI Summary</h4>

                        {disabledSummaryIDs?.disabledKpiSummaryIDs?.map(
                          (item) => (
                            <div
                              key={nanoid()}
                              className={`toggleable_metric ${
                                metricsSummarySelectedForToggle.kpiSelectedFromHidden.includes(
                                  item
                                )
                                  ? "toggled_metric"
                                  : ""
                              }`}
                              onClick={() =>
                                handleSummaryToggle("show", "kpi", item)
                              }
                            >
                              {item?.split("_")?.join(" ")}
                            </div>
                          )
                        )}
                      </div>
                    ) : null}
                    {!disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                      <div className="asymm_toggleable_container">
                        <h4>Asymmetry Summary</h4>

                        {disabledSummaryIDs?.disabledAsymmetrySummaryIDs?.map(
                          (item) => (
                            <div
                              key={nanoid()}
                              className={`toggleable_metric ${
                                metricsSummarySelectedForToggle.asymmSelectedFromHidden.includes(
                                  item
                                )
                                  ? "toggled_metric"
                                  : ""
                              }`}
                              onClick={() =>
                                handleSummaryToggle("show", "asymm", item)
                              }
                            >
                              {item?.split("_")?.join(" ")}
                            </div>
                          )
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="toggle_swapper_button_container">
                <div
                  className="swap_metrics_button"
                  onClick={() => handleSummarySwap()}
                >
                  <SwapIcon size={24} />
                </div>
              </div>
              <div className="toggleable_metric_container">
                <h4>Displayed Metrics Summary</h4>
                <div className="metric_container">
                  <div className="scrollable_content">
                    {/* Scrollable displayed will go here*/}
                    {disabledSummaryIDs.disabledKpiSummaryIDs.filter((item) =>
                      toggledSummaryIDs?.toggledKpiSummaryIDs.includes(item)
                    ).length !==
                      toggledSummaryIDs?.toggledKpiSummaryIDs.length &&
                    !disabledGraphIDs.includes("KPI_Session_Summary") ? (
                      <div className="kpi_toggleable_container">
                        <h4>KPI Summary</h4>

                        {toggledSummaryIDs?.toggledKpiSummaryIDs
                          .filter(
                            (item) =>
                              !disabledSummaryIDs?.disabledKpiSummaryIDs.includes(
                                item
                              )
                          )
                          ?.map((item) => (
                            <div
                              key={nanoid()}
                              className={`toggleable_metric ${
                                metricsSummarySelectedForToggle.kpiSelectedFromDisplayed.includes(
                                  item
                                )
                                  ? "toggled_metric"
                                  : ""
                              }`}
                              onClick={() =>
                                handleSummaryToggle("hide", "kpi", item)
                              }
                            >
                              {item?.split("_")?.join(" ")}
                            </div>
                          ))}
                      </div>
                    ) : null}
                    {disabledSummaryIDs.disabledAsymmetrySummaryIDs.filter(
                      (item) =>
                        toggledSummaryIDs?.toggledAsymmetrySummaryIDs.includes(
                          item
                        )
                    ).length !==
                      toggledSummaryIDs?.toggledAsymmetrySummaryIDs.length &&
                    !disabledGraphIDs.includes("Asymmetry_Session_Summary") ? (
                      <div className="asymm_toggleable_container">
                        <h4>Asymmetry Summary</h4>

                        {toggledSummaryIDs?.toggledAsymmetrySummaryIDs
                          .filter(
                            (item) =>
                              !disabledSummaryIDs?.disabledAsymmetrySummaryIDs.includes(
                                item
                              )
                          )
                          ?.map((item) => (
                            <div
                              key={nanoid()}
                              className={`toggleable_metric ${
                                metricsSummarySelectedForToggle.asymmSelectedFromDisplayed.includes(
                                  item
                                )
                                  ? "toggled_metric"
                                  : ""
                              }`}
                              onClick={() =>
                                handleSummaryToggle("hide", "asymm", item)
                              }
                            >
                              {item?.split("_")?.join(" ")}
                            </div>
                          ))}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="metric_settings_button_container">
              <div
                className="toggleable_metric_button"
                onClick={() => {
                  updateSessionLayout(), handleSaveInitializedButton("summary");
                }}
              >
                <MainButton
                  ButtonIcon={SaveIcon}
                  buttonIconSize={16}
                  buttonLoading={saveActionInitialized.summary}
                  buttonText={
                    !saveActionInitialized.summary ? "Save" : "Saving"
                  }
                  buttonImportant={saveActionInitialized.summary}
                />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SessionSettingsModalBody;
